import * as icons from '@mui/icons-material';
import { Link, List } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MetadataItem, MetadataItemCopy } from 'components/common/metadata/metadata-item';
import { FC } from 'react';
import { CreateTcrCampaignView_tcrDataForTcrCampaignCreation_existingCampaign } from 'types/apollo/CreateTcrCampaignView';
import { formatDate } from 'utils/date';

const HorizontalList = styled(List)`
  display: flex;
  flex-direction: row;
  padding: 0;
`;

export const TcrCampaignInfo: FC<{
  existingCampaign: CreateTcrCampaignView_tcrDataForTcrCampaignCreation_existingCampaign;
}> = ({ existingCampaign }) => {
  const campaignLink = `https://csp.campaignregistry.com/campaigns/${existingCampaign.campaignId}`;
  const brandLink = `https://csp.campaignregistry.com/brands/${existingCampaign.brandId}`;

  return (
    <>
      <HorizontalList>
        <MetadataItemCopy
          label="Campaign ID"
          valueToCopy={existingCampaign.campaignId}
          value={
            <Link target="_blank" href={campaignLink}>
              {existingCampaign.campaignId}
              <icons.OpenInNewOutlined color="action" fontSize="small" />
            </Link>
          }
        />
        <MetadataItemCopy
          label="Brand ID"
          valueToCopy={existingCampaign.brandId}
          value={
            <Link target="_blank" href={brandLink}>
              {existingCampaign.brandId}
              <icons.OpenInNewOutlined color="action" fontSize="small" />
            </Link>
          }
        />
      </HorizontalList>
      <HorizontalList>
        <MetadataItem label="Status" value={existingCampaign.status} />
        <MetadataItem label="Created" value={formatDate(existingCampaign.createDate)} />
        <MetadataItem
          label="Next renewal/expiration date"
          value={existingCampaign.nextRenewalOrExpirationDate}
        />
        <MetadataItem label="Autorenewing" value={existingCampaign.autoRenewal ? 'Yes' : 'No'} />
        <MetadataItem label="Reseller ID" value={existingCampaign.resellerId ?? 'none'} />
        {existingCampaign.mock && <MetadataItem label="Mocked" value="Yes" />}
      </HorizontalList>
    </>
  );
};

export const TcrSharingInfo: FC<{
  sharing: {
    upstreamCnpId?: string | null;
    sharingStatus?: string | null;
    explanation?: string | null;
  } | null;
  Cnp: Record<string, string>;
}> = ({ sharing, Cnp }) => {
  if (!sharing) return null;

  return (
    <HorizontalList>
      {sharing.upstreamCnpId && (
        <MetadataItem
          label="Connectivity partner"
          value={Object.entries(Cnp).find(([_, v]) => v == sharing.upstreamCnpId)?.[0] ?? 'Unknown'}
        />
      )}
      <MetadataItem
        label="Sharing status"
        value={sharing.sharingStatus ?? 'Not shared with connectivity partner'}
      />
      {sharing.explanation && <MetadataItem label="Explanation" value={sharing.explanation} />}
    </HorizontalList>
  );
};
